export default "__VITE_ASSET__CcyyzFZg__"